/**
 * §6.2 Why White-Label — 4 challenge cards that frame the problem.
 */

import React from 'react'
import { Coins, Users, ServerCog, ShieldCheck, Sparkles } from 'lucide-react'
import { Container, Eyebrow, SectionHeading } from '@/components/landing/design-system'
import { CHALLENGES } from '../data'
import { TONE } from '../_shared'

const ICONS = { Coins, Users, ServerCog, ShieldCheck }

export default function WhyWL() {
  return (
    <section className="relative py-24 md:py-28">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-white/15 to-transparent" />
      <Container size="wide" className="flex flex-col gap-10">
        <div className="flex flex-col items-center text-center gap-5 max-w-3xl mx-auto">
          <Eyebrow>Why White-Label</Eyebrow>
          <SectionHeading align="center"
            title={<>Building trading infrastructure{' '}<span className="bg-gradient-to-r from-brand-gold to-[#FFE17A] bg-clip-text text-transparent">from scratch is punishing.</span></>}
            subtitle="Four realities every desk, educator and consultancy runs into when they try to build their own platform."
          />
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
          {CHALLENGES.map((c) => {
            const tone = TONE[c.tone] || TONE.orange
            const Icon = ICONS[c.iconKey] || Sparkles
            return (
              <div key={c.id} className="relative rounded-2xl border border-white/10 bg-white/[0.02] p-5 backdrop-blur-xl transition-all hover:border-white/20 hover:bg-white/[0.03] overflow-hidden">
                <div className="pointer-events-none absolute inset-0 opacity-40"
                  style={{ background: `radial-gradient(80% 40% at 20% 0%, rgba(${tone.rgb},0.10), transparent 70%)` }} />
                <div className="relative flex flex-col gap-3">
                  <span className="inline-flex h-10 w-10 items-center justify-center rounded-xl border"
                    style={{ borderColor: `rgba(${tone.rgb},0.35)`, background: `rgba(${tone.rgb},0.08)`, color: tone.hex }}>
                    <Icon strokeWidth={1.8} style={{ width: 18, height: 18 }} />
                  </span>
                  <div>
                    <h4 className="text-[15px] font-semibold text-white leading-tight">{c.label}</h4>
                    <p className="text-[13px] text-zinc-400 leading-relaxed mt-1.5">{c.body}</p>
                  </div>
                </div>
              </div>
            )
          })}
        </div>

        <div className="rounded-2xl border border-brand-gold/25 bg-brand-gold/[0.05] px-5 md:px-6 py-4 backdrop-blur-xl flex flex-col md:flex-row items-start md:items-center gap-3 md:gap-4">
          <Sparkles className="h-4 w-4 text-brand-gold shrink-0" />
          <p className="text-sm text-zinc-100 leading-relaxed">
            <span className="font-semibold text-white">Kalki Ai Cloud White-Label</span>{' '}
            gives you the platform. You keep the brand, the customers and the revenue.
          </p>
        </div>
      </Container>
    </section>
  )
}
